export interface InterventionDuration {
  repair: number;
  replace: number;
  replaceAdas?: number;
}
